var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterslider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90549 4.25H22C22.4142 4.25 22.75 4.58579 22.75 5C22.75 5.41421 22.4142 5.75 22 5.75H7.90549C7.57245 7.04392 6.39788 8 5 8C3.60212 8 2.42755 7.04392 2.09451 5.75H2C1.58579 5.75 1.25 5.41421 1.25 5C1.25 4.58579 1.58579 4.25 2 4.25H2.09451C2.42755 2.95608 3.60212 2 5 2C6.39788 2 7.57245 2.95608 7.90549 4.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 12C1.25 11.5858 1.58579 11.25 2 11.25H9.09451C9.42754 9.95608 10.6021 9 12 9C13.3979 9 14.5725 9.95608 14.9055 11.25H22C22.4142 11.25 22.75 11.5858 22.75 12C22.75 12.4142 22.4142 12.75 22 12.75H14.9055C14.5725 14.0439 13.3979 15 12 15C10.6021 15 9.42754 14.0439 9.09451 12.75H2C1.58579 12.75 1.25 12.4142 1.25 12Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.25C1.58579 18.25 1.25 18.5858 1.25 19C1.25 19.4142 1.58579 19.75 2 19.75H16.0945C16.4275 21.0439 17.6021 22 19 22C20.3979 22 21.5725 21.0439 21.9055 19.75H22C22.4142 19.75 22.75 19.4142 22.75 19C22.75 18.5858 22.4142 18.25 22 18.25H21.9055C21.5725 16.9561 20.3979 16 19 16C17.6021 16 16.4275 16.9561 16.0945 18.25H2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterslider);
export default __webpack_public_path__ + "static/media/filterslider.a21cc39efe0044902bc852060dbb4d47.svg";
export { ForwardRef as ReactComponent };